import { startCase } from "lodash";
import { FC, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl } from "@ryde/controls";
import { TDrawerCloseFunction } from "@ryde/shared";

import { LayoutRightHeaderTitleStyled } from "../../../right";
import { DrawerCloseIconButton } from "./close-icon-button";
import { DrawerHeaderButton, DrawerHeaderStyled } from "./header.styled";

interface IDrawerHeaderWithSubtitleHistoryProps {
  title: string;
  subTitle?: string;
  onCloseDrawer: TDrawerCloseFunction;
  onHistoryClick?: MouseEventHandler<HTMLButtonElement>;
}

export const DrawerHeaderWithSubtitleHistory: FC<
  IDrawerHeaderWithSubtitleHistoryProps
> = ({ title, subTitle, onCloseDrawer: onClose, onHistoryClick }) => {
  const { t } = useTranslation();
  return (
    <DrawerHeaderStyled>
      <DrawerCloseIconButton onCloseDrawer={onClose} />
      <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
        {startCase(title)}
        {subTitle && <span className="sub_header">{subTitle}</span>}
      </LayoutRightHeaderTitleStyled>
      <AccessControl entity="auditLog" action="read">
        {onHistoryClick && (
          <DrawerHeaderButton
            variant="text"
            onClick={onHistoryClick}
            className="DrawerHeader-History"
            startIcon={<SVG_MUI.History2SVG />}
          >
            {t(`general.HISTORY`)}
          </DrawerHeaderButton>
        )}
      </AccessControl>
    </DrawerHeaderStyled>
  );
};
